<template>
  <form v-if="!submitted" class="stack" @submit.prevent="submit">
    <h4 class="signup-title">{{ $t("newsletter.title") }}</h4>

    <p class="signup-description">{{ $t("newsletter.description") }}</p>
    <div class="signup-fields" :class="{ vertical: direction === 'column' }">
      <input
        v-model="email"
        class="signup-input"
        :class="{ subtle: inputColor === 'subtle' }"
        type="email"
        :placeholder="$t('newsletter.email-placeholder')"
        required
      />
      <BaseButton class="submit-btn text-xl">{{ $t("newsletter.submit") }}</BaseButton>
    </div>
  </form>
  <p class="signup-success" v-else>
    <BaseIcon icon="check-circle" class="primary signup-success-icon" /><span>{{
      $t("newsletter.success")
    }}</span>
  </p>
</template>

<script setup lang="ts">
import { useCreateSubscriberMutation, useNewsletterCategoriesQuery } from "~/graphql/generated";

withDefaults(
  defineProps<{
    direction?: "row" | "column";
    inputColor?: "default" | "subtle";
  }>(),
  {
    direction: "column",
    inputColor: "default",
  },
);

const email = ref("");
const submitted = ref(false);

const newsletters = await useNewsletterCategoriesQuery();
const createSubscriber = useCreateSubscriberMutation();

const submit = async () => {
  const newsletterCategoryIds = newsletters.data.value?.newsletterCategories.map((c) => c.id) ?? [];

  const result = await createSubscriber.executeMutation({
    emailAddress: email.value,
    newsletterCategoryIds,
  });

  if (result.error) {
    console.error(result.error);
    return;
  }

  submitted.value = true;
};
</script>

<style lang="scss" scoped>
.signup-title {
  font-size: 1.125em;
}

.signup-description {
  font-weight: 400;
  font-size: 1em;
  line-height: 22px;
  color: $neutral-800;
}

.signup-success {
  font-weight: 700;
  font-size: 1.125em;
  line-height: 22px;
  color: var(--primary);
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.signup-success-icon {
  flex-shrink: 0;
  margin-top: 0.15em;
}

.signup-input {
  background-color: $light-100;
  border: 1px solid $light-80;
  border-radius: $border-radius;
  color: $dark-100;
  font-size: 1.125em;
  line-height: 1.5rem;
  padding: 1rem;
  width: 100%;

  &::placeholder {
    color: $dark-50;
  }
}

.subtle {
  background-color: #f0f2f5;
  border-color: #f0f2f5;
}

.signup-fields {
  display: flex;
  gap: var(--space, 1rem);

  & > * {
    max-height: 3rem;
  }
}

.vertical {
  flex-direction: column;
}

.submit-btn {
  width: 155px;
  font-family: Inter;
  font-weight: 600;
}
</style>
